import type { ReportData } from '@/types/report';

type ExportableReport = Pick<ReportData, 'id' | 'status'>;

export const isCompletedReport = (report?: ExportableReport | null): boolean => {
    return report?.status?.toLowerCase() === 'completed';
};

export const canExportReport = (report?: ExportableReport | null): boolean => {
    return Boolean(report?.id && isCompletedReport(report));
};
